export class Organization
{
    // Public Properties
    public Addr1: string;
    public Addr2: string;
    public City: string;
    public Country: string;
    public Id: number;
    public IsBusiness: boolean;
    public Name: string;
    public Phone: string;
    public PostalCode: string;
    public State: string;
    public WhenCreated: string;
    public WhenLastUpdated: string;

    constructor(json: object = null)
    {
        this.Addr1 = '';
        this.Addr2 = '';
        this.City = '';
        this.Country = '';
        this.Id = 0;
        this.IsBusiness = true;
        this.Name = '';
        this.Phone = '';
        this.PostalCode = '';
        this.State = '';
        this.WhenCreated = '';
        this.WhenLastUpdated = '';

        if (json)
        {
            Object.assign(this, json);
        }
    }
}

export class OrganizationUpdateModel extends Organization
{
    // Public Properties
    public OrganizationId: number;

    constructor(organization: Organization)
    {
        if (organization)
        {
            super(organization);

            this.OrganizationId = organization.Id;
        }

    }
}
